<div class="flex flex-row w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
  <p-card class="w-96 shrink-0" styleClass="h-full">
    <div class="flex flex-col gap-4">
      <div class="text-lg font-semibold">Versions</div>
      <ul class="list-none m-0 p-0 flex flex-col gap-1">
        @for (info of versions; track info.version) {
          <li class="flex items-center gap-3 p-3 rounded-lg cursor-pointer"
              [class.bg-primary-200]="selectedVersion().version === info.version"
              (click)="selectVersion(info)">
            <i class="fa-light fa-notes"></i>
            <span class="font-medium">{{info.version}} {{info.current ? '(Current)' : ''}}</span>
          </li>
        }
      </ul>
    </div>
  </p-card>

  <p-card class="flex-1" styleClass="h-full">
    <div class="flex flex-col gap-1">
      <div class="text-xl font-semibold">{{versionLabel(selectedVersion())}}</div>
      <div class="text-sm text-surface-500">{{selectedVersion().date}}</div>

      @if (selectedVersion().version == '1.5') {
        <p class="font-semibold">Enhancements</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Create and save TA templates for recurring trips (CLC-7)</li>
          <li>Improve Location Dropdown Typing Behaviour (CLC-83)</li>
          <li>TAs for flight bookings only (CLC-130)</li>
          <li>Show Approvals table for Finalised TAs (CLC-142)</li>
          <li>Add Export to Units and Projects screen (CLC-152)</li>
          <li>Update Business Central Export To Only include Required Payments (CLC-153)</li>
          <li>Quick Access Keyboard Shortcuts (CLC-156)</li>
          <li>Updates to Advanced Search (CLC-177)</li>
          <li>Incidentals and Day trip available in Itinerary Manual Mode (CLC-189)</li>
          <li>Casual staff not an option as a traveller (CLC-190)</li>
          <li>Cancel Pre-payment (CLC-191)</li>
          <li>Flag TAs missing required documentation (CLC-199)</li>
        </ul>

        <p class="font-semibold">Bugs</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Failed itinerary item delete leaves orphan itinerary copy on non-primary traveller (CLC-176)</li>
        </ul>
      }

      @if (selectedVersion().version == '1.4') {
        <p class="font-semibold">Enhancements</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Date picker - time entry doesn't work (CLC-72)</li>
          <li>Note personal day selection in TA in Notification (CLC-102)</li>
          <li>Notify compliance group for overpaid TAs (CLC-104)</li>
          <li>Introduce batch processing for finalisation, pre-payment, and overpayment workflows (CLC-107)</li>
          <li>Align acquittal approval workflow with TA approval workflow (CLC-109)</li>
          <li>Highlight weekends and public holidays in TAs and notifications (CLC-110)</li>
          <li>Day trips (CLC-129)</li>
          <li>Allow Travel Officers to Edit Itinerary (CLC-157)</li>
          <li>Update Packages/Frameworks (CLC-159)</li>
          <li>Multi Input on Basic Search (CLC-178)</li>
          <li>Update Comments to show context tag (CLC-183)</li>
          <li>Handling Multi-day TAs with a $45 last day between Finance and Compliance (CLC-185)</li>
          <li>Better Handling Of Changes to trip duration (CLC-188)</li>
          <li>Do not include day trip amount in Pre-payment or Overpayment (CLC-193)</li>
          <li>Compliance Dashboard Export (CLC-194)</li>
          <li>Enforce No Pre-payment on Day Trips (CLC-195)</li>
          <li>Overseas Locations In TAs (CLC-197)</li>
          <li>Search on TA creator and travel purpose (CLC-177)</li>
        </ul>

        <p class="font-semibold">Bugs</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Deleting Itinerary Day Doesn't work First time (CLC-192)</li>
          <li>Cannot Edit Approver After Withholding (CLC-196)</li>
        </ul>
      }

      @if (selectedVersion().version == '1.3') {
        <p class="font-semibold">Enhancements</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Updates to Cancelling Prepaid TA workflow (CLC-127 & CLC-160)</li>
          <li>Commenting on TAs (comment/chat section) (CLC-132)</li>
          <li>Warn when Submitting a $0 TA (CLC-165)</li>
          <li>TA Summary Card Updates (CLC-168)</li>
          <li>Add new Travel Reason (CLC-174)</li>
        </ul>

        <p class="font-semibold">Bugs</p>
        <ul class="pl-5 list-disc list-inside">
          <li>'Undefined' allowed in project code (CLC-169)</li>
          <li>Itinerary Editing Glitches (CLC-167)</li>
          <li>Unable to select primary approver (CLC-170)</li>
          <li>TA Can Become Stuck in Pending Acquittal (CLC-172) [PATCH]</li>
          <li>Itinerary notes lost (CLC-179) [PATCH]</li>
          <li>Line Manager Cannot View Direct Report's TA (CLC-182) [PATCH]</li>
          <li>Error in Overpaid Calculation (CLC-186) [PATCH]</li>
          <li>Incorrectly Included Incidental Amount in TA (CLC-187) [PATCH]</li>
        </ul>
      }

      @if (selectedVersion().version == '1.2') {
        <p class="font-semibold">Enhancements</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Delegate TA Workflow (CLC-126)</li>
          <li>Pre-payment declaration responsibility on delegated TAs (CLC-112)</li>
          <li>Notify users when a TA is raised on their behalf (CLC-103)</li>
          <li>Search on approver (CLC-133)</li>
          <li>Add TA status to the Business Central export (CLC-106)</li>
          <li>Workflow escalation (CLC-139)</li>
          <li>Notification for Acquittal withhold (CLC-140)</li>
          <li>Show TA Number for In Progress TAs (CLC-150)</li>
          <li>Admin ability to override the approval workflow (CLC-93)</li>
          <li>Finance notifications/dashboard enhancements (CLC-100)</li>
          <li>Show pre-pay and overpaid status in TA list view (CLC-105)</li>
          <li>Manager Dashboard Update (CLC-124)</li>
          <li>Prevent duplicate TA finalisation (CLC-154)</li>
          <li>Allow overpayment processing on finalised TAs (CLC-155)</li>
          <li>Update active TA hierarchy (CLC-136)</li>
          <li>Don't show funding/out of region Approvals in dashboards until required (CLC-163)</li>
        </ul>
        <p class="font-semibold">Bugs</p>
        <ul class="pl-5 list-disc list-inside">
          <li>TA Value/Estimate sometimes displays wrong value (CLC-149/CLC-135)</li>
          <li>Project codes with 'undefined' (CLC-143)</li>
          <li>Clicking Prepayment Processed failing (CLC-147)</li>
          <li>Some Audit Events failing to save (CLC-148)</li>
        </ul>
      }

      @if (selectedVersion().version == '1.1') {
        <p class="font-semibold">Enhancements</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Implement Casual Travellers (CLC-119)</li>
          <li>Updates to Entra Refresh (CLC-125)</li>
          <li>More defensive checks submitting TA for Approval (CLC-120)</li>
          <li>Update approval workflow to be sequential (not concurrent) (CLC-56)</li>
        </ul>
        <p class="font-semibold">Bugs</p>
        <ul class="pl-5 list-disc list-inside">
          <li>Admins Cannot Execute Withhold (CLC-121)</li>
          <li>Fixed estimate not updating sometimes</li>
          <li>Fixed issue with already actioned pre-payments possibly still appearing in dashboard</li>
          <li>Fixed errors editing travellers</li>
          <li>Fixed manual mode toggle bug</li>
          <li>Search result report (CLC-134)</li>
          <li>Fixed inactive users not showing in search admin</li>
          <li>Cancelling non pre-paid TA while in Pending Approval triggers incorrect notification (CLC-138)</li>
        </ul>
      }

      @if (selectedVersion().version == '1.0') {
        <ul class="pl-5 list-disc list-inside">
          <li>First release</li>
        </ul>
      }

    </div>
  </p-card>
</div>
